import { defineStore } from "pinia";

export const useEmployerStore = defineStore('employer', {
    state: () => {
      return {
        employers: [{ value: 0, label: { en: 'all Employers' } }]
      }
    },
    persist: true,
});